const norm = (s) => (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();

// Labels that come from the product itself rather than from free attributes
const STANDARD = {
  'numero d article': 'ref',
  'numero article': 'ref',
  reference: 'ref',
  'notre prix': 'price',
  prix: 'price',
  fabricant: 'brand',
  marque: 'brand',
  'numero de ean': 'ean',
  'numero ean': 'ean',
  ean: 'ean',
  etat: 'condition',
};

export const standardKey = (label) => STANDARD[norm(label)] || null;

// Free attribute value, tolerant to accents/case differences in the label
export const attrValue = (product, label) => {
  const attrs = product.attributes || {};
  return attrs[label] ?? attrs[Object.keys(attrs).find((k) => norm(k) === norm(label))];
};

export const specTemplate = (category, subcategory) => {
  const fields = category?.spec_fields || {};
  return (subcategory && fields[subcategory]) || fields['*'] || null;
};

const formatPrice = (p) => `${Number(p || 0).toFixed(2).replace('.', ',')} €`;

// Rows for the product page: [label, value, kind] following the template order
export const buildSpecRows = (product, template) => {
  const rows = [];
  for (const label of template) {
    const key = standardKey(label);
    if (key === 'ref') rows.push([label, product.ref, 'text']);
    else if (key === 'price') rows.push([label, formatPrice(product.price), 'text']);
    else if (key === 'brand') rows.push([label, product.brand, 'brand']);
    else if (key === 'ean') { if (product.ean) rows.push([label, product.ean, 'text']); }
    else if (key === 'condition') rows.push([label, product.condition || 'Neuf', 'text']);
    else {
      const v = attrValue(product, label);
      if (v) rows.push([label, v, 'text']);
    }
  }
  return rows;
};

export const CONDITIONS = ['Neuf', 'Reconditionné', 'Occasion'];
